/* jshint esversion: 6 */
import $ from 'jquery';
import nowAndLater from './nowAndLater';

$(document).on('hide.bs.collapse', '.accordion', function(e) {
    if ($(e.target).parent().parent().data('color')) {
        $(e.target).parent().children().css('border-left', 'none');
    }
});

$(document).on('show.bs.collapse', '.accordion', function(e) {
    if ($(e.target).parent().parent().data('color')) {
        let color = $(e.target).parent().parent().data('color');
        if (color === 'primaryColor' && $('#primaryColor').length > 0) {
            color = $('#primaryColor').css('background-color');
        }
        $(e.target).parent().children().css('border-left', '4px solid ' + color);
    }
});

nowAndLater('.accordion .card', target => {
    if ($(target).parent().data('color') && $(target).find('.collapse.show').length > 0) {
        let color = $(target).parent().data('color');
        if (color === 'primaryColor' && $('#primaryColor').length > 0) {
            color = $('#primaryColor').css('background-color');
        }
        $(target).children().css('border-left', '4px solid ' + color);
    }
});
